import React, { useState } from 'react';
import { inscrireVendeur } from '../../services/vendeurs/vendeurService';
import '../../styles/vendeurs/VendeurRegisterForm.css';
import { Eye, EyeOff } from 'lucide-react'; 


function VendeurRegisterForm() {
  const [formData, setFormData] = useState({
    nom: '',
    prenom: '',
    email: '',
    telephone: '',
    modePaiement: '',
    motDePasse: '',
    confirmation: '',
    cin_recto: null,
    cin_verso: null,
    residence: null,
    photo_profil: null,
  });

  const [previewPhoto, setPreviewPhoto] = useState(null);
  const [erreurs, setErreurs] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (files && files.length > 0) {
      const file = files[0];
      setFormData((prev) => ({ ...prev, [name]: file }));

      if (name === 'photo_profil') {
        try {
          const preview = URL.createObjectURL(file);
          setPreviewPhoto(preview);
        } catch (err) {
          console.error('Erreur de prévisualisation image :', err);
        }
      }
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^\d{10}$/;
    const erreursTemp = {};

    if (!emailRegex.test(formData.email)) {
      erreursTemp.email = 'Adresse email invalide.';
    }
    if (!phoneRegex.test(formData.telephone)) {
      erreursTemp.telephone = 'Le numéro de téléphone doit contenir exactement 10 chiffres.';
    }
    if (formData.motDePasse.length < 6) {
      erreursTemp.motDePasse = 'Le mot de passe doit contenir au moins 6 caractères.';
    }
    if (formData.motDePasse !== formData.confirmation) {
      erreursTemp.confirmation = 'Les mots de passe ne correspondent pas.';
    }

    if (Object.keys(erreursTemp).length > 0) {
      setErreurs(erreursTemp);
      return;
    }

    try {
      await inscrireVendeur(formData);
      alert("Inscription envoyée. Attente de validation par l'admin.");
      localStorage.setItem('vendeurConnecte', JSON.stringify({
        nom: formData.nom,
        prenom: formData.prenom,
        photo_profil: formData.photo_profil?.name,
        email: formData.email,
      }));
      setFormData({
        nom: '', prenom: '', email: '', telephone: '', modePaiement: '',
        motDePasse: '', confirmation: '', cin_recto: null, cin_verso: null,
        residence: null, photo_profil: null,
      });
      setErreurs({});
      setPreviewPhoto(null);
    } catch (error) {
      console.error('Erreur inscription vendeur :', error);
      if (error?.response?.status === 409) {
        alert("Cet email est déjà utilisé.");
      } else {
        alert("Erreur : " + (error?.message || "Erreur inconnue"));
      }
    }
  };

  return (
    <div className="vendeur-form-container">
      <h2>Inscription Vendeur</h2>

      <form className="vendeur-form-grid" onSubmit={handleSubmit} encType="multipart/form-data">
        <div className="form-full">
          <div className="photo-upload-wrapper">
            <label htmlFor="photo_profil" className="photo-upload-circle">
              {previewPhoto ? (
                <img src={previewPhoto} alt="Profil" className="photo-preview" />
              ) : (
                <span className="photo-upload-icon">📷</span>
              )}
            </label>
            <input
              id="photo_profil"
              type="file"
              name="photo_profil"
              accept="image/*"
              onChange={handleChange}
              required
              hidden
            />
          </div>

          {Object.keys(erreurs).length > 0 && (
            <div className="global-error">Veuillez corriger les champs en rouge</div>
          )}
        </div>

        <div className="form-col">
          {["nom", "prenom", "email"].map((field) => (
            <div className="vendeur-form-group" key={field}>
              <label>{field.charAt(0).toUpperCase() + field.slice(1)}:</label>
              <input
                type={field === "email" ? "email" : "text"}
                name={field}
                value={formData[field]}
                onChange={handleChange}
                required
              />
            </div>
          ))}

          <div className="vendeur-form-group">
            <label>Numéro de téléphone:</label>
            <input
              type="tel"
              name="telephone"
              value={formData.telephone}
              inputMode="numeric"
              maxLength={10}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*$/.test(value) && value.length <= 10) {
                  handleChange(e);
                }
              }}
              required
            />
            {erreurs.telephone && <p className="erreur">{erreurs.telephone}</p>}
          </div>
        </div>

        <div className="form-col">
          <div className="vendeur-form-group">
            <label>Mode de paiement:</label>
            <select
              name="modePaiement"
              value={formData.modePaiement}
              onChange={handleChange}
              required
            >
              <option value="">--Choisir--</option>
              <option value="orangeMoney">Orange Money</option>
              <option value="mvola">MVola</option>
              <option value="airtelMoney">Airtel Money</option>
            </select>
          </div>

          {["cin_recto", "cin_verso", "residence"].map((fileField) => (
            <div className="vendeur-form-group" key={fileField}>
              <label>{fileField.replace("_", " ").toUpperCase()}:</label>
              <input
                type="file"
                name={fileField}
                accept="image/*"
                onChange={handleChange}
                required
              />
            </div>
          ))}
        </div>

        <div className="form-full">
            {[{
              label: 'Mot de passe',
              name: 'motDePasse',
              show: showPassword,
              toggle: () => setShowPassword(!showPassword)
            }, {
              label: 'Confirmation mot de passe',
              name: 'confirmation',
              show: showConfirm,
              toggle: () => setShowConfirm(!showConfirm)
            }].map(({ label, name, show, toggle }) => (
              <div className="vendeur-form-group" key={name}>
                <div className="password-toggle">
                  <input
                    type={show ? 'text' : 'password'}
                    name={name}
                    placeholder={label}
                    value={formData[name]}
                    onChange={handleChange}
                    required
                  />
                  <span className="password-toggle-icon" onClick={toggle}>
                    {show ? <EyeOff size={18} /> : <Eye size={18} />}
                  </span>
                </div>
                {erreurs[name] && <p className="erreur">{erreurs[name]}</p>}
              </div>
            ))}

          <button type="submit">Envoyer</button>
          <p className="connexion-link">
            Vous avez déjà un compte ? <a href="/vendeur/login">Se connecter</a>
          </p>
        </div>
      </form>
    </div>
  );
}

export default VendeurRegisterForm;
